angular.module('leanlaw.core').factory('timerManager', ['$interval', 'global', 'leanLawApi', 'matterManager', function ($interval, global, leanLawApi, matterManager) {
  const _timers = [];
  const Timer = function (info, restoring) {
    this.id = info.id;
    this.matter = info.matter;
    this.description = info.description || '';
    this.totalHours = info.totalHours || 0;
    this.timeElapsed = info.timeElapsed || 0;
    this.newTimeElapsed = info.timeElapsed || 0;
    this.startTime = info.startTime || new Date();
    this.lastTime = info.lastTime || new Date();
    this.timing = false;
    this.timeInterval = null;
    this.created = typeof info.created === 'object' ? new Date().toDateString() : info.created || new Date().toDateString();
    if (info.timing) {
      // The timer was running when the server last heard about it, so account for
      // everything accrued since. elapsed is only written on start and pause, so for a
      // timer that has been going for hours it is stale, and lastStarted is the only
      // record of how long the timer has actually run.
      //
      // There is no ceiling on that gap. This used to stop reconstructing once it passed
      // 24 hours and leave the timer stopped, on the theory that nobody means to run one
      // that long -- but they do, and the result was a 25-hour timer coming back showing
      // seconds. Desktop and mobile rebuild it the same way.
      this.timing = false;
      const delta = Date.now() - this.lastTime.getTime();

      // Only ever add. A clock behind the server's puts lastStarted in the future, and a
      // negative delta would quietly shorten the entry.
      if (delta > 0) {
        this.timeElapsed += delta;
        // newTimeElapsed is the draft the inline editor writes back through setNewTime().
        // Left at the stale server value, editing the time would discard everything
        // reconstructed on the line above.
        this.newTimeElapsed += delta;
      }
      this.start(restoring);
    }
  };
  Timer.prototype.delete = function () {
    // this.pause();
    for (let i = 0; i < _timers.length; i++) {
      if (this.id === _timers[i].id) {
        _timers.splice(i, 1);
        leanLawApi.deleteTimer({
          id: this.id
        });
        return;
      }
    }
  };
  Timer.prototype.hasUnsavedTime = function () {
    return this.timeElapsed > 0;
  };
  Timer.prototype.getElapsedHours = function () {
    return this.timeElapsed / 1000 / 60 / 60; // Convert milliseconds to hours (the save function applies the firm's rounding setting)
  };
  Timer.prototype.reset = function () {
    this.timeElapsed = 0;
    this.newTimeElapsed = 0;
    this.timeElapsedTotal = 0;
    this.timing = false;
    this.lastUsed = Date.now();
    this.save();
    return this;
  };
  Timer.prototype.save = function () {
    const timer = this;
    if (!timer.id) {
      console.log("Timer can't be saved because it doesn't have id");
      return;
    }
    if (!timer.matter || !timer.matter.hasOwnProperty('id')) timer.matter = null;
    if (timer.timeElapsed < 0) throw new Error('Cannot save timer with negative time', timer.id);
    leanLawApi.updateTimer({
      id: timer.id,
      body: timerToApi(timer)
    }).catch(err => {
      console.error(`Failed to update timer ${err}`);
    });
    return this;
  };
  Timer.prototype.timeString = function (useNewTimeElapsed) {
    let te = this.timeElapsed;
    if (useNewTimeElapsed) te = this.newTimeElapsed;
    const ms = te % 1000;
    let s = (te - ms) / 1000;
    let secs = s % 60;
    s = (s - secs) / 60;
    let mins = s % 60;
    let hrs = (s - mins) / 60;

    // Zero pad short values
    mins = `${mins}`.length == 1 ? `0${mins}` : mins;
    hrs = `${hrs}`.length == 1 ? `0${hrs}` : hrs;
    secs = `${secs}`.length == 1 ? `0${secs}` : secs;
    return `${hrs}:${mins}:${secs}`;
  };
  Timer.prototype.start = function (restoring) {
    const timer = this;
    if (timer.timing) {
      // Already timing- keep going!
      return;
    }
    pauseAllTimers();
    if (!timer.timeElapsed) {
      timer.startTime = Date.now();
    }

    // Don't include the time that the project was paused
    timer.lastTime = Date.now();

    // Queue system project for time
    timer.timeInterval = $interval(() => {
      const delta = Date.now() - timer.lastTime;
      timer.timeElapsed += delta;
      timer.newTimeElapsed += delta; // Also update new times
      timer.lastTime = Date.now();
    }, 100);
    timer.timing = true;
    if (!restoring) {
      timer.save();
    }
    return this;
  };
  Timer.prototype.pause = function () {
    // don't do anything if project isn't going
    if (!this.timing) return;

    // Stop updating timeElapsed
    $interval.cancel(this.timeInterval);
    this.timeInterval = null;
    this.timing = false;
    this.save();
    return this;
  };
  function timerToApi(timer) {
    const json = {
      id: timer.id,
      description: timer.description,
      elapsed: timer.timeElapsed,
      running: timer.timing
    };
    if (timer.matter) {
      json.matter = {
        id: timer.matter.id
      };
    }
    if (timer.startTime) {
      json.firstStarted = new Date(timer.startTime).toISOString();
    }
    if (timer.lastTime) {
      json.lastStarted = new Date(timer.lastTime).toISOString();
    }
    return json;
  }
  function createTimer(info, restoring) {
    if (!info) info = {};
    const timer = new Timer(info, restoring);
    if (info.start) {
      // Start it but avoid saving before creating
      timer.start(true);
    }
    _timers.unshift(timer);
    if (!restoring) {
      syncToRemote(timer);
    }
    return timer;
  }
  function syncToRemote(timer) {
    leanLawApi.createTimer({
      body: timerToApi(timer)
    }).then(created => {
      timer.id = created.id;
    }).catch(err => {
      console.error(`Failed to create timer ${err}`);
    });
  }
  function createNewTimerInPlaceFor(oldTimerId, oldTimer) {
    const {
      matter,
      client,
      billing
    } = oldTimer;
    const newTimer = new Timer({
      matter,
      billing
    });
    newTimer.matter.client = client;
    newTimer.client = client;
    const oldPosition = Math.max(0, _timers.findIndex(t => t.id === oldTimerId));
    _timers.splice(oldPosition, 0, newTimer);
    syncToRemote(newTimer);
    return newTimer;
  }
  function getTimerById(timerId) {
    return _.find(_timers, t => t.id == timerId);
  }
  function restore(storedTimers) {
    _timers.length = 0;
    if (!storedTimers) return [];
    return matterManager.list().then(matters => {
      for (let i = 0; i < storedTimers.length; i++) {
        const timer = storedTimers[i];
        const info = {
          id: timer.id,
          description: timer.description,
          startTime: timer.firstStarted ? new Date(timer.firstStarted) : null,
          lastTime: timer.lastStarted ? new Date(timer.lastStarted) : null,
          timeElapsed: Math.max(timer.elapsed, 0),
          // Clamp
          timing: timer.running
        };
        const newTimer = createTimer(info, true);
        if (timer.matter) {
          const matter = matters.find(m => m.id?.toLowerCase() === timer.matter.id?.toLowerCase());
          if (matter) {
            newTimer.matter = matter;
            newTimer.client = matter.client;
          }
        }
      }
    });
  }
  function timerRunning() {
    return !_.isUndefined(_.find(_timers, t => t.timing));
  }
  function pauseAllTimers() {
    _.each(_timers, t => {
      if (t.timing) {
        t.pause();
      }
    });
  }
  function matterExists(matter, matters) {
    return !_.isUndefined(_.find(matters, m => m.id == matter.id));
  }
  function filter(matters) {
    const remove = _.filter(_timers, t => t.matter && !matterExists(t.matter, matters));
    _.each(remove, t => {
      t.delete();
    });
  }
  function load() {
    // initialize timers by loading them from storage
    return leanLawApi.listTimers().then(list => restore(list.timers));
  }
  global.ready.then(() => {
    load();
  });
  return {
    timers: _timers,
    createTimer,
    getTimerById,
    timerRunning,
    filter,
    load,
    createNewTimerInPlaceFor
  };
}]);